var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-user-types", style: _vm.cssVars },
    _vm._l(_vm.typesList, function (item, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "mobile-user-types__item",
          on: {
            click: function ($event) {
              return _vm.handleClick(item)
            },
          },
        },
        [
          _c("div", { staticClass: "mobile-user-types__icon-wrap" }, [
            _c("img", {
              staticClass: "mobile-user-types__icon",
              attrs: { src: _vm.getTypeIcon(item.type), alt: "" },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mobile-user-types__name" }, [
            _vm._v(_vm._s(item.name)),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }